export const BLOTTER_TAB = [ 'spot', 'forward', 'pending', 'kondor', 'position' ] as const;
export type EBlotterTab = typeof BLOTTER_TAB[number];
